import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { NfcCard, Query } from 'graphql/generated/graphqlTypes';
import { generateMockAccessGrant } from 'mocks/graphqlMocks/accessGrant';
import { mockDoorOfficeModeWeekDays, mockDoorReader1, mockDoorSwingHandle1 } from 'mocks/graphqlMocks/doorFixtures';
import { generateMockLocation } from 'mocks/graphqlMocks/location';
import { generateMockVisitor } from 'mocks/graphqlMocks/visitor';
import { mockVisitorsWithGroups } from 'mocks/graphqlMocks/visitorFixtures';
import { generateMockVisitorGroup } from 'mocks/graphqlMocks/visitorGroup';
import { generateMockWeekSchedule } from 'mocks/graphqlMocks/weekSchedule';

dayjs.extend(utc);

const VISITOR_IDS_WITH_ISSUES = [
  'mockVisitorId12',
  'mockVisitorId15',
  'mockVisitorId16',
  'mockVisitorId17',
  'mockVisitorId18',
  'mockVisitorId19',
  'mockVisitorId20'
];

export const cleanGetAllVisitorsForTenantData: Pick<Query, 'getVisitors'> = {
  getVisitors: mockVisitorsWithGroups.filter((visitor) => !VISITOR_IDS_WITH_ISSUES.includes(visitor.id))
};

export const cleanDoors = [mockDoorReader1, mockDoorSwingHandle1];

export const cleanGetDoorsForTenantData: Pick<Query, 'getDoorsForTenant'> = {
  getDoorsForTenant: cleanDoors
};

const cleanLocation = generateMockLocation({
  id: 'cleanLocationId',
  name: 'Main Building',
  doors: cleanDoors,
  doorIds: cleanDoors.map((door) => door.id)
});

export const cleanGetLocationsForTenantData: Pick<Query, 'getLocationsForTenant'> = {
  getLocationsForTenant: [cleanLocation]
};

const cleanVisitorGroup = generateMockVisitorGroup({
  id: 'cleanVisitorGroupId',
  name: 'All Staff',
  members: [generateMockVisitor({ id: 'cleanGroupMemberId', name: 'Clean Group Member' })],
  accessGrants: [
    generateMockAccessGrant({
      id: 'cleanAccessGrantId',
      locations: [cleanLocation],
      locationIds: [cleanLocation.id],
      accessSchedule: generateMockWeekSchedule({ weekDays: mockDoorOfficeModeWeekDays })
    })
  ]
});

export const cleanGetVisitorGroupsForTenantData: Pick<Query, 'getVisitorGroupsForTenant'> = {
  getVisitorGroupsForTenant: [cleanVisitorGroup]
};

const cleanCards: NfcCard[] = [
  {
    name: '#CLEAN001',
    uuid: '#CLEAN001',
    updateRequired: false,
    __typename: 'NfcCard',
    assignment: {
      expiryDate: dayjs().utc().add(1, 'year').toISOString(),
      blocked: null,
      expired: false,
      visitor: null,
      visitorName: 'Clean Card Holder'
    }
  },
  {
    name: '#CLEAN002',
    uuid: '#CLEAN002',
    updateRequired: false,
    __typename: 'NfcCard',
    assignment: {
      expiryDate: dayjs().utc().add(2, 'year').toISOString(),
      blocked: null,
      expired: false,
      visitor: null,
      visitorName: 'Another Clean Holder'
    }
  }
];

export const cleanGetAccessCardsData: Pick<Query, 'getNfcCards'> = {
  getNfcCards: cleanCards
};

export const emptyGetAllVisitorsForTenantData: Pick<Query, 'getVisitors'> = {
  getVisitors: []
};

export const emptyGetDoorsForTenantData: Pick<Query, 'getDoorsForTenant'> = {
  getDoorsForTenant: []
};

export const emptyGetLocationsForTenantData: Pick<Query, 'getLocationsForTenant'> = {
  getLocationsForTenant: []
};

export const emptyGetVisitorGroupsForTenantData: Pick<Query, 'getVisitorGroupsForTenant'> = {
  getVisitorGroupsForTenant: []
};

export const emptyGetAccessCardsData: Pick<Query, 'getNfcCards'> = {
  getNfcCards: []
};
